<div class="tvd-bucket flex flex-col h-full bg-white"
    [ngClass]="[
        !isSubComponent ? 'rounded-[18px] md:w-80 xl:min-w-96' : '',
        (selectedItem && makingSelectionsState) ? 'border-solid border-2 border-blue rounded-[18px]' :
        isSubComponent ? 'neptune-border-t-1 border-t-sky-blue' : 'border-solid border-1 border-sky-blue rounded-[18px]'
    ]"
>

    <div *ngIf="tvdDataIsEmptyString(data)" class="flex justify-center items-center">
        <loader size='large'></loader>
    </div>

    <div *ngIf="!tvdDataIsEmptyString(data) && data!=undefined" class="tvd-container flex flex-col grow">
        <div class="tvd-container-header flex items-center justify-between min-h-10"
            [ngClass]="[
                isSubComponent ? '' : (selectedItem && makingSelectionsState) ? 'neptune-border-b-2 border-blue' : 'neptune-border-b-1 border-sky-blue',
                isSubComponent ? 'pt-2 justify-between' : 'px-6',
                (isSubComponent && selectedItem && makingSelectionsState) ? 'px-2' : '',
                !isBusinessMetric() ? 'py-4' : ''
            ]"
        >
            <div class="tvd-title flex gap-2 items-center">
                <img *ngIf="metricId | eroi:'metricIcon' as icon" [src]="icon" [ngClass]="isSubComponent ? 'w-6 h-6' : 'w-9 h-9'" alt="tvd-metric-icon">
                <div id="box-text" class="flex items-center text-blue" [ngClass]="isSubComponent ? 'text-base min-h-base-clamp' : 'text-2xl min-h-2xl-clamp'">{{ metricId | eroi:'title':{showInEnterpriseTerms: showInEnterpriseTerms} }}</div>
            </div>

            <ng-container *ngIf="!isCostAssumptionsPreview && isCostAssumptionsEditable && this.defaultCostCenterMetrics.includes(title!)">
                <button id="{{title}}" class="tvd-pencil-icon items-center justify-center bg-blue px-3 py-2 rounded-[128px] cursor-pointer" (click)="openSideDrawer()">
                        <img src="assets/shared-icons/neptune-icon-white-pencil.svg"  class="w-5 h-5" alt="pencil-icon" />
                </button>
            </ng-container>
        </div>

        <div class="tvd-container-body flex flex-col grow gap-3"
            [ngClass]="[
                isSubComponent ? 'pb-4' : 'p-6',
                (isSubComponent && selectedItem && makingSelectionsState) ? 'px-2' : ''
            ]"
        >
            <div class="tvd-contribution flex flex-col grow gap-4">
                <div *ngIf="!isBusinessMetric()" class="tvd-monetary-contribution flex flex-col gap-4">
                    <span class="font-bold" [ngClass]="isSubComponent ? 'text-xl' : 'text-4xl'">{{costCurrencyCode | currencySymbol}}{{displayInRoundedNumber ? (metricData.currentMonetaryContribution | abbreviateNumber) : metricData.currentMonetaryContribution}}</span>
                    <ng-container *ngIf="metricData.defaultMonetaryContribution && isDefaultMetrics(title!,metricData.defaultMonetaryContribution, 'monetary') && isDefaultCostAssumptionsVisible">
                        <span class="font-bold text-shuttle-gray" [ngClass]="isSubComponent ? 'text-base' : 'text-2xl'">Default <span class="tvd-default-value">{{costCurrencyCode | currencySymbol}}{{displayInRoundedNumber ? (metricData.defaultMonetaryContribution | abbreviateNumber) : metricData.defaultMonetaryContribution}}</span></span>
                    </ng-container>
                </div>
                <div *ngIf="isBusinessMetric()" class="tvd-bucket-cost text-3xl font-bold" >{{metricData.currentValueContribution}}</div>


                <div *ngIf="!isBusinessMetric()"class="tvd-value-contribution flex flex-col">
                    <p [ngClass]="isSubComponent ? 'text-sm' : 'text-base'"><span class="font-bold">{{metricData.currentValueContribution}}</span> {{ metricId | eroi:'units':{measurementSystem: measurementSystem} }}</p>
                    <ng-container *ngIf="metricData.defaultValueContribution && isDefaultMetrics(title!,metricData.defaultValueContribution, 'value') && isDefaultCostAssumptionsVisible">
                        <p class="tvd-default-value text-shuttle-gray" [ngClass]="isSubComponent ? 'text-xs' : 'text-sm'">Default <span class="font-bold">{{metricData.defaultValueContribution}}</span> {{ metricId | eroi:'units':{measurementSystem: measurementSystem} }}</p>
                    </ng-container>
                </div>

                <ng-container *ngIf="addedToPres">
                    <div class="added-indicator text-neptune-neutral px-4 py-2 text-sm rounded-md bg-mocassin bg-opacity-60 w-max font-medium">Added</div>
                </ng-container>
            </div>

            <!-- Footer of tile is either View Details button or the Add/Remove from presentation button -->
            <!-- Distributor Business metrics should not show Add/Added nor "View Details" button -->
            <!-- If division is Distributor and makingSelectionState is true, do not show Add/Added nor "View Details" button -->
            <ng-container *ngIf="!(isBusinessMetric() || (isDistributorView() && makingSelectionsState))">
                <ng-container *ngIf="makingSelectionsState; else viewDetailsButton">
                    <button id="{{title}}" class="add-tile-to-presentation flex justify-center items-center px-3 py-2"
                        [ngClass]="{ 
                            'neptune-button-blue': selectedItem, 
                            'neptune-button-white': !selectedItem,
                            'cursor-not-allowed': disableSelectionButton,
                            'cursor-pointer': !disableSelectionButton }"
                        (click)="toggleSelectItem(title)"
                        >
                        <ng-container *ngIf="!selectedItem; else resetSelection">
                            <span class="text-sm">Add</span>
                            <img src="assets/shared-icons/neptune-icon-blue-plus-sign.svg" *ngIf="!selectedItem" class="w-5 h-5" alt="plus-icon" />
                        </ng-container>
                        <ng-template #resetSelection>
                            <span class="text-sm">Added</span>
                            <img src="assets/shared-icons/neptune-icon-white-tick.svg" *ngIf="selectedItem" class="w-5 h-5" alt="tick-icon" />
                        </ng-template>
                    </button>
                </ng-container>

                <ng-template #viewDetailsButton>
                    <!-- View Details Button should not be shown in Cost Assumptions Preview -->
                    <div *ngIf="!isCostAssumptionsPreview" class="view-details-button neptune-button-white flex justify-center items-center px-3 py-2 cursor-pointer box-border"
                        (click)="ViewDetailsByLocation()"
                        [ngClass]="isSubComponent ? 'rounded-[128px] text-sm max-w-[168px]' : ''">
                        View Details
                        <img src="assets/shared-icons/neptune-icon-blue-chevron-right.svg" class="!h-5 !w-5 block" alt="arrow-right-icon"/>
                    </div>
                </ng-template>
            </ng-container>
        </div>
    </div>

    <ng-container *ngIf="isDrawerOpen">
        <app-tvd-sidenavbar
        [isOpen]="isDrawerOpen"
        [drilldownComponentTitle]="metricId"
        (closeSideDrawer)="closeSideDrawer()"
        [isInMetric]=true>
        </app-tvd-sidenavbar>
    </ng-container>

</div>
